module.exports = __webpack_public_path__ + "img/icn_lock_finale.15236823.png";